import * as React from 'react';
import { useTheme } from "@mui/material";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';


const StyledTableCell = styled(TableCell)(({ theme }) => ({

  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#FEF0DE",
    color: theme.palette.common.black,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


export default function DummyTable(props) {

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
            <TableRow>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            <StyledTableRow>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
                <StyledTableCell align="left"><Skeleton></Skeleton></StyledTableCell>
            </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}